<template>
  <el-dialog :title="id==0 ? '添加文章' : '编辑文章'" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="67%" @open="addOpen" :fullscreen="true" :show-close="false" :close-on-click-modal="false">
    <el-form :model="formData" :rules="formRules" ref="formRef" label-width="80px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="formData.title" style="width: 30%;"></el-input>
      </el-form-item>
      <el-form-item label="封面图" prop="pic">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/admin/upload_img"
            name="img"
            :show-file-list="false"
            :on-success="handleSuccess">
            <img v-if="picUrl" :src="picUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
      <el-form-item label="分类" prop="category_id">
        <el-select v-model="formData.category_id" placeholder="请选择分类" filterable>
          <el-option :key="0" label="请选择分类" :value="0"></el-option>
          <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="canEditAuthor" label="作者" prop="author_id">
        <el-select v-model="formData.author_id" placeholder="请选择作者" filterable>
          <el-option v-for="item in authorList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-upload :show-upload-list="false"
          :on-success="handleQuillSuccess"
          :format="['jpg','jpeg','png','gif']"
          :max-size="2048" multiple
          action="/proxy/admin/upload_img"
          name="img"
          style="display: none;">
          <el-button id="quill_upload" icon="ios-cloud-upload-outline" ></el-button>
        </el-upload>
        <el-upload :show-upload-list="false"
          :before-upload="handleMediaQuillUpload"
          :on-success="handleMediaQuillSuccess"
          action="/proxy/admin/upload_media"
          name="media"
          style="display: none;">
          <el-button id="quill_upload_media"></el-button>
        </el-upload>
        <quill-editor ref="quillEditorRef" v-model="formData.content" :options="editorOption" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm" :disabled="confirmDisable">确 定</el-button>
    </span>
    <upload-process
      :visible="uploading"
      :upPercent="upPercent"
    >
    </upload-process>
  </el-dialog>
</template>

<script>
import * as qiniu from 'qiniu-js'
import md5 from 'js-md5'
import UploadProcess from '../uploadProcess.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Quill from 'quill'
import { quillEditor } from 'vue-quill-editor'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{ header: 1 }, { header: 2 }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ size: ['small', false, 'large', 'huge'] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image', 'video'],
  ['sourceEditor']
]

export default {
  name: 'category_add',
  props: [
    'visible', 'id', 'categoryList', 'authorList', 'canEditAuthor'
  ],
  components: {
    'upload-process': UploadProcess,
    'quill-editor': quillEditor
  },
  data () {
    return {
      formData: {
        title: '',
        pic: '',
        category_id: 0,
        author_id: 0,
        recommended: 0,
        content: ''
      },
      confirmDisable: false,
      fullscreenLoading: false,
      editorOption: {
        placeholder: '编辑配置内容',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image (value) {
                if (value) {
                  document.querySelector('#quill_upload').click()
                }
              },
              video (value) {
                if (value) {
                  document.querySelector('#quill_upload_media').click()
                }
              }
            }
          },
          imageDrop: true,
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          }
        }
      },
      picUrl: '',
      formRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        pic: [
          { required: true, message: '封面不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '内容不能为空', trigger: 'blur' }
        ]
      },
      uploading: false,
      upPercent: 0,
      uploadPrepareResp: {}
    }
  },
  methods: {
    closeDialog () {
      this.$refs.formRef.resetFields()
      this.picUrl = ''
      this.$emit('close')
    },
    addConfirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        // 验证通过
        this.confirmDisable = true
        this.picUrl = ''
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.getInfo(this.id)
      }
      this.confirmDisable = false
      this.uplodPrepare()
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/article/info/' + id)
      if (res.code === 0) {
        this.formData = {
          title: res.data.title,
          pic: res.data.pic,
          category_id: res.data.category_id,
          author_id: res.data.author_id,
          recommended: res.data.recommended,
          content: res.data.content
        }
        this.picUrl = res.data.pic_url
      }
    },
    async uplodPrepare (fileName) {
      const res = await this.$http.get('/admin/upload_prepare')
      if (res.code === 0) {
        this.uploadPrepareResp = res.data
      }
    },
    handleSuccess (resp, file, fileList) {
      if (resp.code === 0) {
        this.picUrl = resp.data.url
        this.formData.pic = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    },
    handleQuillSuccess (res) {
      // 获取富文本组件实例
      const quill = this.$refs.quillEditorRef.quill
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        const length = quill.getSelection().index
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res.data.url)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        console.log('图片插入失败')
      }
    },
    handleMediaQuillUpload (file) {
      const fileNameArr = file.name.split('.')
      const key = 'media/' + md5(file.name + Date.now()) + '.' + fileNameArr[1]
      const putExtra = { fname: key }
      const config = { useCdnDomain: false, region: qiniu.region.z0 } // 根据需要选择区域
      const observable = qiniu.upload(file, key, this.uploadPrepareResp.up_token, putExtra, config)
      this.uploading = true
      const next = (res) => {
        // 可以在这里添加上传进度条更新的代码
        this.upPercent = Math.ceil(res.total.percent)
      }
      const error = (err) => {
        this.$message.error(err.message)
      }
      const complete = (res) => {
        // 上传完成后的处理逻辑
        const pointIndex = res.key.lastIndexOf('.')
        const fileType = res.key.substring(pointIndex + 1)
        const mediaUrl = this.uploadPrepareResp.res_domain + res.key
        if (fileType === 'mp3' || fileType === 'ogg' || fileType === 'm4a') {
          this.insertAudio(mediaUrl)
        } else {
          this.insertVideo(mediaUrl)
        }
        this.uploading = false
        this.upPercent = 0
      }
      observable.subscribe({ next, error, complete })
      return false
    },
    handleMediaQuillSuccess (res) {
      if (res.code === 0) {
        const pointIndex = res.data.path.lastIndexOf('.')
        const fileType = res.data.path.substring(pointIndex + 1)
        if (fileType === 'mp3' || fileType === 'ogg' || fileType === 'm4a') {
          this.insertAudio(res.data.url)
        } else {
          this.insertVideo(res.data.url)
        }
      } else {
        console.log('图片音频或视频失败')
      }
    },
    insertAudio (url) {
      const quill = this.$refs.quillEditorRef.quill
      const length = quill.getSelection().index
      quill.insertEmbed(length, 'audio', { url: url }, 'api')
      quill.setSelection(length + 1)
    },
    insertVideo (url) {
      const quill = this.$refs.quillEditorRef.quill
      const length = quill.getSelection().index
      quill.insertEmbed(length, 'video', url)
      quill.setSelection(length + 1)
    }
  }
}
</script>

<style scoped>
</style>
